import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { getUserDetails } from "../../services/authService";
import "./TopSectionEvents.css";

const DEFAULT_AVATAR = "/icons/default_user.png";

export default function TopSectionEvents({
  title,
  searchValue,
  onSearchChange,
}) {
  const history = useHistory();
  const userId = localStorage.getItem("user_id");
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!userId) return;
    let cancel = false;
    setLoading(true);
    (async () => {
      try {
        const res = await getUserDetails(userId);
        if (!cancel && res.success) setUserData(res.user);
      } catch (err) {
        console.error(err);
      } finally {
        if (!cancel) setLoading(false);
      }
    })();
    return () => { cancel = true; };
  }, [userId]);

  const avatarSrc =
    userData?.photographer_profile?.image_url?.trim() || DEFAULT_AVATAR;

  const handleUserClick = () => {
    if (!userId) return history.push("/login");
    if (loading || !userData) return;
    history.push(`/user-details/${userId}`, { to_update: true, userData });
  };

  const handleImgError = (e) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = DEFAULT_AVATAR;
  };

  return (
    <div
      className="top-section-events blur-background blur-top"
      style={{ "--circle-size": "200px", "--translate-x": "-10%", "--translate-y": "-30%" }}
    >
      {/* logo + user */}
      <div className="logo-container-top">
        <div className="logo-container-event">
          <Link to="/">
            <img src="/icons/logo.png" alt="Logo" className="logo" />
          </Link>
        </div>

        {!loading && (
          <div
            className="user-image-container-event"
            onClick={handleUserClick}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => e.key === "Enter" && handleUserClick()}
            style={{ cursor: "pointer" }}
          >
            <img
              src={avatarSrc}
              alt="User"
              className="user-avatar"
              onError={handleImgError}
            />
          </div>
        )}
      </div>

      {/* title */}
      <div className="top-title-event">
        <span className="event-name-container-name">{title}</span>
        <span className="event-name-container-manage">נהל כאן את האירועים שלך</span>
      </div>

      {/* search */}
      <div className="search-input">
        <img src="/icons/search.png" className="search-icn" alt="Search" />
        <input
          type="text"
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="חפש כאן אירוע"
        />
      </div>
    </div>
  );
}
